import React, { useRef } from "react";
import { MetaPixel } from "./components/MetaPixel";
import { Hero } from "./components/Hero";
import { ProblemSection } from "./components/ProblemSection";
import { TransformationSection } from "./components/TransformationSection";
import { BeforeAfterSection } from "./components/BeforeAfterSection";
import { FamiliarSection } from "./components/FamiliarSection";
import { WhyCreatedSection } from "./components/WhyCreatedSection";
import { VolumesSection } from "./components/VolumesSection";
import { BonusesSection } from "./components/BonusesSection";
import { OfferSection } from "./components/OfferSection";
import { GuaranteeSection } from "./components/GuaranteeSection";
import { TestimonialsSection } from "./components/TestimonialsSection";
import { AboutSection } from "./components/AboutSection";
import { FAQSection } from "./components/FAQSection";
import { FinalCTASection } from "./components/FinalCTASection";
import { Footer } from "./components/Footer";
import { FloatingCTA } from "./components/FloatingCTA";
import { PurchasePopup } from "./components/PurchasePopup";
import { useScrolledPast } from "./hooks/useScrolledPast";
export function App() {
  const firstCtaRef = useRef<HTMLDivElement>(null);
  const showFloating = useScrolledPast(firstCtaRef);
  return <div className="min-h-screen w-full bg-canvas font-sans text-ink" data-id="element-0" data-mp="6801qozk67w">
      <MetaPixel data-id="element-1" data-mp="2zl3dbpgpde7f" />
      <Hero firstCtaRef={firstCtaRef} data-id="element-2" data-mp="2zllijblcf2rh" />
      <main data-id="element-3" data-mp="2zmwif0bo3qdb">
        <ProblemSection data-id="element-4" data-mp="2zn6bwxvx8fnr" />
        <TransformationSection data-id="element-5" data-mp="33mf25srr5vek" />
        <BeforeAfterSection data-id="element-6" data-mp="33nq5jrhad155" />
        <FamiliarSection data-id="element-7" data-mp="33mylndx1wrup" />
        <WhyCreatedSection data-id="element-8" data-mp="38lrqkhy9vaj9" />
        <VolumesSection data-id="element-9" data-mp="38li7lebna3n2" />
        <BonusesSection data-id="element-10" data-mp="38k6ugnwb7jja" />
        <OfferSection data-id="element-11" data-mp="38num1hi71vvd" />
        <GuaranteeSection data-id="element-12" data-mp="3dkl58dpap7l0" />
        <TestimonialsSection data-id="element-13" data-mp="3dlw5w4ng1z7w" />
        <AboutSection data-id="element-14" data-mp="3dm60k5jfoujx" />
        <FAQSection data-id="element-15" data-mp="nvj4bi5joiqs" />
        <FinalCTASection data-id="element-16" data-mp="nw2ak1lu1ioz" />
      </main>
      <Footer data-id="element-17" data-mp="nv0ypuwzss67" />
      <FloatingCTA visible={showFloating} data-id="element-18" data-mp="nxn5vtfz15nw" />
      <PurchasePopup raised={showFloating} data-id="element-19" data-mp="su43rfcz2ye6" />
    </div>;
}